import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TaskComponent } from './task/task';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';

@NgModule({
	declarations: [
		TaskComponent
	],
	imports: [
		CommonModule,
		IonicModule
	],
	exports: [
		TaskComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts